import { getConditionalPropertyValue } from '@unifyapps/carbon/utils/conditionalValues';
import type { CheckboxContent } from '@unifyapps/defs/types/blocks';
import type { TypographyColors } from '@unifyapps/defs/types/typography';
import { useMemo } from 'react';

export function useGetAddOnsStyle(addOns: CheckboxContent['addOns']) {
  const labelStyles = useMemo(() => {
    return {
      color: getConditionalPropertyValue<TypographyColors>({ value: addOns?.label?.color }),
      weight: addOns?.label?.weight ?? 'medium',
      variant: addOns?.label?.variant ?? 'text-sm',
    };
  }, [addOns?.label]);

  const descriptionStyles = useMemo(() => {
    return {
      color: getConditionalPropertyValue<TypographyColors>({ value: addOns?.description?.color }),
      weight: addOns?.description?.weight,
      variant: addOns?.description?.variant ?? 'text-xs',
    };
  }, [addOns?.description]);

  const helpStyles = useMemo(() => {
    return {
      color: getConditionalPropertyValue<TypographyColors>({ value: addOns?.help?.color }),
      weight: addOns?.help?.weight,
      variant: addOns?.help?.variant ?? 'text-xs',
    };
  }, [addOns?.help]);

  return { labelStyles, descriptionStyles, helpStyles };
}
